import { setup } from "bem-cn";
export const styleBlock = setup({
    ns: `kit__`,
    mod: "--",
});
//# sourceMappingURL=styleBlock.js.map